import { NetworkStatusService } from '@library/services/qp-network-status/qp-network-status.service';
import { QpNotificationBarService } from '@library/services/qp-notification-bar/qp-notification-bar.service';
import { Injectable, inject } from '@angular/core';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusAlertService {
  public readonly _networkStatusService = inject(NetworkStatusService);
  public readonly _qpNotificationBarService = inject(QpNotificationBarService);
  public readonly _iconReg = inject(SvgIconRegistryService);

  public constructor() {
    // Preload icons used in the offline notification bar
    this._iconReg.loadSvg('ngx-qima/assets/icons/error-filled.svg')?.subscribe();
    this._iconReg.loadSvg('ngx-qima/assets/icons/cross-small.svg')?.subscribe();
  }

  public subscribeToNetworkEvents(): void {
    this._networkStatusService.isOnline$.pipe(skip(1)).subscribe((isOnline: boolean): void => {
      if (isOnline) {
        this._qpNotificationBarService.success('global.network.backOnline');

        return;
      }

      this._qpNotificationBarService.error('global.network.offline');
    });
  }
}
